'use strict';
angular.module('departmentManageModule', []).
controller('departmentManageController', ['$scope', '$timeout', '$q', '$stateParams', '$location', '$state', '$window', 'treeService', 'trsHttpService', 'modalDialog', 'trsspliceString', 'departmentManuCommonService', 'localStorageService', 'permissionService',
    function($scope, $timeout, $q, $stateParams, $location, $state, $window, treeService, trsHttpService, modalDialog, trsspliceString, departmentManuCommonService, localStorageService, permissionService) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态22
         */
        function initStatus() {
            $scope.data = {
                selectedArray: [],
            };
            $scope.status={
                parentid:$stateParams.parentid,
            };
            $scope.queryCompanyParams = {
                serviceid: "mlf_departdoc",
                methodname: "queryDeparts",
                ParentId: $scope.status.parentid,
                SearchKey:"",
            };
        };
        /**
         * [initData description]初始化数据
         */
        function initData() {
            requestData();
        };
        /**
         * [requestData description] 获取部门
         * @return {[type]} [description]
         */
        function requestData() {
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), $scope.queryCompanyParams, "get").then(function (data) {
                $scope.lists = data;
                $scope.data.selectedArray = [];
            });
        };
        /**
         * [departSearch description;检索:根据用户真实姓名模糊查询用户列表(全文检索)]
         * @param  {[type]} ev [description:按下空格也能提交]
         */
        $scope.departSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.queryCompanyParams.SearchKey=$scope.data.keywords;
                requestData();
                $scope.data.selectedArray = [];
            }
        };
        /**
         * [getDepartIds description:删除部门]
         */
        function deleteDepart(){
            var selectedIds=trsspliceString.filter($scope.data.selectedArray, "DEPARTMENTALDOCID", "");
            $scope.deleteCompanyParams={
                serviceid:"mlf_departdoc",
                methodname:"removeDeparts",
                DepartmentaldocIds:selectedIds.join(",")
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),$scope.deleteCompanyParams,'get').then(function(data){
                if(data.ISSUCCESS=='true'){
                    modalDialog.alertType('删除成功', '', 'success', false, function() {
                        requestData();
                    });
                }
            });
        }
        /**
         * [isShowDepart description:是否显示单位]
         */
        function isShowDepart(type,ids){
            $scope.isShowDepartsParams={
                serviceid:"mlf_departdoc",
                methodname:type,
                DepartmentaldocIds:ids
            };
            var confirmTips=type=='displayDeparts'?'显示':'隐藏';
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),$scope.isShowDepartsParams,'get').then(function(data){
                if(data.ISSUCCESS=='true'){
                    modalDialog.alertType(confirmTips+'成功', "", "success", false, function () {
                        requestData();
                    });
                }
            });
        }
        /**
         * [switchBen description单选] 点击显示或者隐藏单位
         */
        $scope.switchBtn = function (item) {
            var confirmInfo = item.ISHIDE=='1'? "选中部门开启显示，是否继续？" : "选中部门将被隐藏，是否继续？";
            modalDialog.alertType(confirmInfo, "", "ask", true, function () {
                if(item.ISHIDE=='0'){
                    isShowDepart('hideDeparts',item.DEPARTMENTALDOCID);
                    item.ISHIDE='1';
                }else{
                    isShowDepart('displayDeparts',item.DEPARTMENTALDOCID);
                    item.ISHIDE='0';
                }
            });
        };
        /**
         * [selectAll description:全选]
         */
        $scope.selectAll = function () {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.lists.length ? [] : [].concat($scope.lists);
        };
        /**
         * [selectDoc 单选]
         * @param  {[type]} item [description：单个对象]
         */
        $scope.selectDoc = function (item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
        };
        /**
         * [createNewCompany description] 新建部门
         */
        $scope.createNewDepart = function () {
            departmentManuCommonService.createDepartmentManu("", "create").then(function (data) {
                requestData();
            });
        };
        /**
         * [editCompany description] 编辑单位
         */
        $scope.editDepart=function(item){
            departmentManuCommonService.createDepartmentManu(item, "edit").then(function (data) {
                requestData();
            });
        };
        /**
         * [deleteCompany description]删除部门
         */
        $scope.deleteDepart = function () {
            modalDialog.alertType("", "删除部门将不可恢复，是否继续？", "warning", true, function() {
                deleteDepart();
            });
        };
        /**
         * [hideCompany description]隐藏部门
         */
        $scope.hideDepart = function () {
            var selectedIds=trsspliceString.filter($scope.data.selectedArray, "DEPARTMENTALDOCID", "");
            modalDialog.alertType("选中部门将被隐藏，是否继续？", "", "ask", true, function () {
                isShowDepart('hideDeparts',selectedIds.join(","));
            });
        };
        /**
         * [initShowCompany description]显示单位
         */
        $scope.initShowDepart  = function () {
            var selectedIds=trsspliceString.filter($scope.data.selectedArray, "DEPARTMENTALDOCID", "");
            modalDialog.alertType("选中部门开启显示，是否继续？", "", "ask", true, function () {
                isShowDepart('displayDeparts',selectedIds.join(","));
            });
        };
        /**
         * [dragoverCallback description;允许拖拽]
         */
        $scope.dragoverCallback = function (event, index, external, type) {
            return true;
        };
        /**
         * [dragStart description;拖拽开始]
         */
        $scope.dragStart = function (event, item, index) {
            $scope.status.dragStartIndex = index;
        };
        /**
         * [dragStdropCallbackart description;拖拽结束]
         */
        $scope.dropCallback = function(event, index, item, external, type, allowedType) {
            if ($scope.status.dragStartIndex == index) {
                return;
            }
            var params = {
                serviceid: 'mlf_departdoc',
                methodname: 'orderDepartDocs',
                StartDepartId: $scope.lists[$scope.status.dragStartIndex].DEPARTMENTALDOCID,
                EndDepartId: $scope.status.dragStartIndex > index ? $scope.lists[index].DEPARTMENTALDOCID : $scope.lists[index - 1].DEPARTMENTALDOCID,
                ParentId:$scope.status.parentid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function() {
                requestData();
            });
        };
    }
]);